<label *ngIf="label" [for]="id"
  >{{ label }} <app-dc-popover *ngIf="helpText" [body]="helpText" [class.helpText]="helpText"></app-dc-popover
></label>
<input
  [formControl]="control"
  [type]="type"
  [class]="'form-control input'"
  [readonly]="readonly"
  [placeholder]="placeholder == undefined ? '' : placeholder"
  autocomplete="new-input"
  [id]="id"
/>
